import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.562 4.447c-1.13-2.262-1.696-3.393-2.436-3.766a2.5 2.5 0 0 0-2.252 0c-.74.373-1.305 1.504-2.436 3.766-.307.614-.46.921-.67 1.161a2.5 2.5 0 0 1-.994.694c-.298.113-.632.15-1.302.225-2.332.259-3.498.388-4.073.863a2.5 2.5 0 0 0-.835 2.53c.18.723 1.052 1.533 2.798 3.154.543.505.815.757.993 1.044a2.5 2.5 0 0 1 .368 1.487c-.024.337-.145.682-.387 1.372-.786 2.242-1.18 3.363-1.032 4.052a2.5 2.5 0 0 0 2.23 1.965c.702.06 1.765-.471 3.89-1.534l.787-.393c.656-.328.984-.492 1.328-.557.305-.057.617-.057.922 0 .344.065.672.229 1.328.557l.787.393c2.125 1.063 3.188 1.594 3.89 1.534a2.5 2.5 0 0 0 2.23-1.965c.148-.689-.245-1.81-1.032-4.052-.242-.69-.363-1.035-.387-1.372a2.5 2.5 0 0 1 .368-1.487c.178-.287.45-.54.994-1.044 1.745-1.621 2.618-2.431 2.797-3.155a2.5 2.5 0 0 0-.835-2.53c-.575-.474-1.74-.603-4.073-.862-.67-.075-1.004-.112-1.302-.225a2.5 2.5 0 0 1-.994-.694c-.21-.24-.363-.547-.67-1.16Z"
    />
  </svg>
)
export default SvgComponent
